import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stationImage',
  standalone: true,
  pure: true,
})
export class StationImagePipe implements PipeTransform {
  transform(Topic: string): string {
    return `images/stations/${Topic}.webp`;
  }
}
